const wordCount = value => {
	if ( !value ) {
		return 0;
	}

	return value.toString()
		.trim()
		.split( ' ' ).length;
};

export default wordCount;
